import React, { useRef } from 'react'
import { Button, Descriptions, Typography } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const { Text } = Typography

const Show = () => {
  const fetchRef = useRef(null)
  const { t } = useLocalization()
  const params = useParams()

  const handleReload = () => {
    fetchRef.current.reload()
  }

  const fetch = async () => {
    const result = await client
      .get(`/specialist/${params.id}`)
      .then((res) => res.data)
    return result
  }

  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {(data) => (
        <PageLayout
          title={t('specialty.showScreen.title')}
          editPath={`/specialties/${params.id}/edit`}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('specialty.showScreen.reload')}
            </Button>,
          ]}
        >
          <Descriptions column={1}>
            <Descriptions.Item
              label={<Text strong>{t('specialty.showScreen.label.name')}</Text>}
            >
              {data.name}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <Text strong>{t('specialty.showScreen.label.detail')}</Text>
              }
            >
              {data.detail}
            </Descriptions.Item>
          </Descriptions>
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Show
